/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useSelector } from 'react-redux';

const PretestInfo = ({ closeModal }) => {
  const course_detail = useSelector((state) => state.course_detail);
  return course_detail ? (
    <div
      className="d-flex flex-column justify-content-around modal-hosted-course"
      style={{ flex: '1' }}
    >
      <h1 className="assignment__title mb-3" style={{ fontWeight: '700' }}>
        Halo!
      </h1>
      <h2 className="rating__desc_3 align-self-center" style={{ textAlign: 'center' }}>
        Selamat datang di kelas
      </h2>
      <h2
        className="rating__desc_3 align-self-center"
        style={{ textAlign: 'center', fontWeight: '700' }}
      >{`${course_detail.name}!`}</h2>
      <h2 className="rating__desc_1 align-self-start mt-4 mb-4" style={{ textAlign: 'left' }}>
        <p style={{ fontSize: '14px', marginBottom: '4px', fontWeight: '700' }}>
          Sebelum melakukan pembelajaran, silahkan Anda mengerjakan Pre-Test terlebih dahulu.
        </p>
        Hasil dari Pre-Test ini akan dijadikan perbandingan dengan nilai{' '}
        <span style={{ fontWeight: '700' }}>"Exam"</span> yang Anda dapatkan. Hal tersebut bertujuan
        untuk mengukur seberapa besar kemampuan Anda dalam menyerap materi pembelajaran. Pre-Test
        ini terdiri atas (banyak soal dan jenis soalnya).{' '}
        <span style={{ fontWeight: '700' }}>Terima kasih dan selamat belajar!</span>
      </h2>
      <div className="rating__btn align-self-stretch d-flex flex-column">
        <a
          className="btn btn-lg btn-pink align-self-stretch"
          style={{ fontSize: '16px' }}
          onMouseDown={() => {
            closeModal();
          }}
        >
          Mulai Sekarang
        </a>
      </div>
    </div>
  ) : (
    ''
  );
};

export default PretestInfo;
